import { Button } from "@mui/material";
import React, { useContext } from "react";

import { useTranslation } from "react-i18next";
import AppContext from "../../../../Contexts/AppContext";
import WrongLocationIcon from "@mui/icons-material/WrongLocation";
import BrowserNotSupportedIcon from "@mui/icons-material/BrowserNotSupported";
export const ExitDrawPolygonModeButton = () => {
  const { t } = useTranslation("main");
  const { modeOptions, resetAddPolygon } = useContext(AppContext);

  const handleExitEditMode = async () => {
    resetAddPolygon();
  };

  return (
    <Button
      sx={{
        display: modeOptions.ADD_POLYGON.length > 0 ? "" : "none",
        opacity: 0.7,
        "&:hover": {
          opacity: 1,
        },
      }}
      onClick={handleExitEditMode}
      className="mapButton"
      endIcon={<BrowserNotSupportedIcon />}
      color="error"
      variant="contained"
    >
      {t("exit_draw_polygon_mode")}
    </Button>
  );
};
